import { api } from "@/api";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function getCajaActualAperturaActual(): Promise<CajaApertura> {
    await sleep(1000);
    const response = await api.get("caja_actual/open");
    return response.data;
}

export function useGetCajaActualAperturaActualQuery(queryConfig: QueryConfig<CajaApertura> = {}) {
    return useQuery({
        ...queryConfig,
        queryKey: ["caja_actual", "open"],
        queryFn: getCajaActualAperturaActual
    })
}

export interface GetCajaActualAperturaActualQueryProps {
    queryConfig?: QueryConfig<CajaApertura>,
    children?: (queryResult: QueryResult<CajaApertura>) => ReactNode
}

export function GetCajaActualAperturaActualQuery({
    children,
    queryConfig
}: GetCajaActualAperturaActualQueryProps) {
    const queryResult = useGetCajaActualAperturaActualQuery(queryConfig);
    return children && children(queryResult);
}